// Généré par connecteur/generate-color-swatches.js — NE PAS ÉDITER À LA MAIN.
// Nom de coloris midOcean → couleur CSS (pastille réelle sur la fiche produit).
window.RD_COLOR_MAP = {
 "Abricot": "#f4a15d",
 "Anthracite": "#3c3c42",
 "Anthracite Chine": "linear-gradient(135deg, #737377 0%, #3c3c42 45%, #67676c 100%)",
 "Anthracite Chine/Noir": "linear-gradient(135deg, #3c3c42 50%, #141414 50%)",
 "Aqua": "#5fc9d8",
 "Argent": "#c6c9cc",
 "Argent Brillant": "linear-gradient(135deg, #dadcde 0%, #c6c9cc 55%, #d1d4d6 100%)",
 "Argent Mat": "#c6c9cc",
 "Army": "#4a5240",
 "Army/Army Fonce": "linear-gradient(135deg, #4a5240 50%, #4a5240 50%)",
 "Army/Beige": "linear-gradient(135deg, #4a5240 50%, #d9c7a7 50%)",
 "Army/Beige Natural": "linear-gradient(135deg, #4a5240 50%, #e9dfc9 50%)",
 "Astral Purple": "#6a4b9c",
 "Azure": "#3d84c6",
 "Beige": "#d9c7a7",
 "Beige Chine": "linear-gradient(135deg, #e4d7c0 0%, #d9c7a7 45%, #e1d3ba 100%)",
 "Beige Fonce": "#988b75",
 "Beige Naturel/Beige": "linear-gradient(135deg, #e9dfc9 50%, #d9c7a7 50%)",
 "Beige/Blanc": "linear-gradient(135deg, #d9c7a7 50%, #ffffff 50%)",
 "Beige/Rouge": "linear-gradient(135deg, #d9c7a7 50%, #c8102e 50%)",
 "Black/Charcoal Grey": "linear-gradient(135deg, #141414 50%, #36363b 50%)",
 "Blan/Vert Fluo": "#5aff00",
 "Blanc": "#ffffff",
 "Blanc /French Marine": "linear-gradient(135deg, #ffffff 50%, #1f2a44 50%)",
 "Blanc 2": "#ffffff",
 "Blanc Absolu": "#ffffff",
 "Blanc Cassé": "#f2ede2",
 "Blanc Chiné": "linear-gradient(135deg, #ffffff 0%, #ffffff 45%, #ffffff 100%)",
 "Blanc Optique": "#ffffff",
 "Blanc Recyclé": "#ffffff",
 "Blanc Transparent": "#ffffff",
 "Blanc/Aqua": "linear-gradient(135deg, #ffffff 50%, #5fc9d8 50%)",
 "Blanc/Bleu": "linear-gradient(135deg, #ffffff 50%, #2f6db4 50%)",
 "Blanc/Bleu Foncé": "linear-gradient(135deg, #ffffff 50%, #2f6db4 50%)",
 "Blanc/Corail Fluo": "linear-gradient(135deg, #ffffff 50%, #f26d5f 50%)",
 "Blanc/French Marine": "linear-gradient(135deg, #ffffff 50%, #1f2a44 50%)",
 "Blanc/Fuchsia": "linear-gradient(135deg, #ffffff 50%, #c73a83 50%)",
 "Blanc/Gris": "linear-gradient(135deg, #ffffff 50%, #9a9aa0 50%)",
 "Blanc/Gris Chine": "linear-gradient(135deg, #ffffff 50%, #9a9aa0 50%)",
 "Blanc/Jaune Fluo": "linear-gradient(135deg, #ffffff 50%, #f2c500 50%)",
 "Blanc/Jaune Néon": "linear-gradient(135deg, #ffffff 50%, #f2c500 50%)",
 "Blanc/Marine": "linear-gradient(135deg, #ffffff 50%, #1f2a44 50%)",
 "Blanc/Noir": "linear-gradient(135deg, #ffffff 50%, #141414 50%)",
 "Blanc/Orange": "linear-gradient(135deg, #ffffff 50%, #e87722 50%)",
 "Blanc/Orange Fluo": "linear-gradient(135deg, #ffffff 50%, #e87722 50%)",
 "Blanc/Rouge": "linear-gradient(135deg, #ffffff 50%, #c8102e 50%)",
 "Blanc/Royal": "linear-gradient(135deg, #ffffff 50%, #1e4fbd 50%)",
 "Blanc/Royal/Rouge": "#ffffff",
 "Blanc/Turquoise": "linear-gradient(135deg, #ffffff 50%, #30b8c4 50%)",
 "Blanc/Vert Pomme": "linear-gradient(135deg, #ffffff 50%, #7cb342 50%)",
 "Bleu": "#2f6db4",
 "Bleu Abysse": "#2f6db4",
 "Bleu Arctique": "#2f6db4",
 "Bleu Ardoise": "#2f6db4",
 "Bleu Atoll": "#3aa6b9",
 "Bleu Bugatti": "#2f6db4",
 "Bleu Bébé": "#8dafd6",
 "Bleu Canard": "#2f6db4",
 "Bleu Caraibes": "#2f6db4",
 "Bleu Ciel Chine": "linear-gradient(135deg, #b8d4ec 0%, #9cc3e5 45%, #b2d0eb 100%)",
 "Bleu Clair": "#8dafd6",
 "Bleu Clair Transparent": "#f2f6f8",
 "Bleu Cremeux": "#f3ecd8",
 "Bleu Fonce": "#214c7e",
 "Bleu Fonce Cremeux": "#aaa597",
 "Bleu Glacier": "#a7adb5",
 "Bleu Intense": "#2f6db4",
 "Bleu Léger": "#2f6db4",
 "Bleu Marine": "#1f2a44",
 "Bleu Moyen": "#2f6db4",
 "Bleu Petrole": "#1f5f6b",
 "Bleu Rayé": "#2f6db4",
 "Bleu Royal": "#1e4fbd",
 "Bleu Transparent": "#e8eef2",
 "Bleu/Blanc": "linear-gradient(135deg, #2f6db4 50%, #ffffff 50%)",
 "Bois": "#a97d4f",
 "Bordeaux": "#6d1a2b",
 "Bordeaux Moyen": "#6d1a2b",
 "Camo Bleu": "#2f6db4",
 "Camo Gris": "#9a9aa0",
 "Camo/Royal Blue": "#1e4fbd",
 "Camouflage": "conic-gradient(#e0533d 0 25%, #f2c500 0 50%, #2e8b46 0 75%, #2f6db4 0 100%)",
 "Champagne": "#e8d9a8",
 "Chili": "#b0312a",
 "Chocolat": "#4c3423",
 "Chocolat Fonce": "#352419",
 "Chocolat/Beige": "linear-gradient(135deg, #4c3423 50%, #d9c7a7 50%)",
 "Ciel": "#9cc3e5",
 "Ciel Piqué": "#9cc3e5",
 "Ciel Vif": "#9cc3e5",
 "Citron": "#f2e34c",
 "Corail": "#f26d5f",
 "Corail Fluo": "#f48377",
 "Corde": "#c7b08a",
 "Couleurs Assorties": "conic-gradient(#e0533d 0 25%, #f2c500 0 50%, #2e8b46 0 75%, #2f6db4 0 100%)",
 "Creme": "#f3ecd8",
 "Cuivré": "#b06a3b",
 "Denim": "#3b5f8a",
 "Denim Brut": "#3b5f8a",
 "Denim Chine": "linear-gradient(135deg, #728cab 0%, #3b5f8a 45%, #6682a4 100%)",
 "Denim/Lin": "linear-gradient(135deg, #3b5f8a 50%, #d8cfc0 50%)",
 "Dusty Beige": "#d9c7a7",
 "Dusty Green": "#2e8b46",
 "Ecru": "#efe8d4",
 "Ecru/Aqua/Lin": "#efe8d4",
 "Ecru/Denim/French Marine": "#efe8d4",
 "Ecru/French Marine/Rouge Vif": "#efe8d4",
 "Ecru/Rose Bonbo": "linear-gradient(135deg, #efe8d4 50%, #e58cb6 50%)",
 "Emeraude": "#159570",
 "Folk Pink Twin": "#e58cb6",
 "Folk Red Twin": "#c8102e",
 "French Marine": "#1f2a44",
 "French Marine 2": "#1f2a44",
 "French Marine Chiné / French Marine": "linear-gradient(135deg, #1f2a44 50%, #1f2a44 50%)",
 "French Marine/Blanc": "linear-gradient(135deg, #1f2a44 50%, #ffffff 50%)",
 "French Marine/Orange Fluo": "linear-gradient(135deg, #1f2a44 50%, #e87722 50%)",
 "French Marine/Rouge Vif": "linear-gradient(135deg, #1f2a44 50%, #c8102e 50%)",
 "French Marine/Royal": "linear-gradient(135deg, #1f2a44 50%, #1e4fbd 50%)",
 "Fuchsia": "#c73a83",
 "Fuchsia Transparent": "#e8eef2",
 "Fuschia Fluo": "#ff3d8c",
 "Graphite": "#4a4a50",
 "Gris": "#9a9aa0",
 "Gris 2": "#9a9aa0",
 "Gris Anthracite": "#3c3c42",
 "Gris Carbon/Noir": "linear-gradient(135deg, #9a9aa0 50%, #141414 50%)",
 "Gris Carbone": "#9a9aa0",
 "Gris Chine Clair": "linear-gradient(135deg, #d7d7da 0%, #c7c7cb 45%, #d3d3d6 100%)",
 "Gris Chine Fonce": "linear-gradient(135deg, #959598 0%, #6c6c70 45%, #8c8c8f 100%)",
 "Gris Chine/Orange": "linear-gradient(135deg, #9a9aa0 50%, #e87722 50%)",
 "Gris Chiné": "linear-gradient(135deg, #b6b6bb 0%, #9a9aa0 45%, #b0b0b5 100%)",
 "Gris Chiné II": "linear-gradient(135deg, #b6b6bb 0%, #9a9aa0 45%, #b0b0b5 100%)",
 "Gris Chiné Recyclé": "linear-gradient(135deg, #b6b6bb 0%, #9a9aa0 45%, #b0b0b5 100%)",
 "Gris Clair": "#c7c7cb",
 "Gris Flanelle": "#9a9aa0",
 "Gris Fonce": "#6c6c70",
 "Gris Fonce/Orange": "linear-gradient(135deg, #9a9aa0 50%, #e87722 50%)",
 "Gris Foncé/Gris": "linear-gradient(135deg, #9a9aa0 50%, #9a9aa0 50%)",
 "Gris Léger": "#9a9aa0",
 "Gris Metal": "#9a9aa0",
 "Gris Moyen": "#9a9aa0",
 "Gris Perle": "#9a9aa0",
 "Gris Pierre": "#b5aea3",
 "Gris Pur": "#9a9aa0",
 "Gris Souris": "#8f8f96",
 "Gris Titanium": "#9a9aa0",
 "Gris Transparent": "#e8eef2",
 "Gris/Bordeaux": "linear-gradient(135deg, #9a9aa0 50%, #6d1a2b 50%)",
 "Gris/Marine": "linear-gradient(135deg, #9a9aa0 50%, #1f2a44 50%)",
 "Grisca/Beige Natural": "linear-gradient(135deg, #9a9aa0 50%, #e9dfc9 50%)",
 "Hibiscus": "#b43a4e",
 "Indigo": "#2c3e77",
 "Ivoire": "#f6f1de",
 "Jaune": "#f2c500",
 "Jaune Clair": "#f8df73",
 "Jaune Fluo": "#e8ff00",
 "Jaune Pâle": "#f2c500",
 "Jaune Transparent": "#e8eef2",
 "Kaki": "#6b6b47",
 "Kaki Chiné": "linear-gradient(135deg, #94947b 0%, #6b6b47 45%, #8c8c6f 100%)",
 "Kaki Foncé": "#4b4b32",
 "Kaki Intense": "#6b6b47",
 "Light Graphite": "#9b9b9f",
 "Lilas": "#c5aed3",
 "Lime": "#9bd333",
 "Lime Fluo": "#5aff00",
 "Lime/Blanc": "linear-gradient(135deg, #9bd333 50%, #ffffff 50%)",
 "Limestone": "#b5aea3",
 "Linen Twin": "#d8cfc0",
 "Marine": "#1f2a44",
 "Marine Prowear": "#1f2a44",
 "Marine Recyclé": "#1f2a44",
 "Marine/Royal": "linear-gradient(135deg, #1f2a44 50%, #1e4fbd 50%)",
 "Marron": "#6b4a2f",
 "Medium Orange": "#e87722",
 "Mint": "#9adbb4",
 "Multicolore": "conic-gradient(#e0533d 0 25%, #f2c500 0 50%, #2e8b46 0 75%, #2f6db4 0 100%)",
 "Naturel": "#e9dfc9",
 "Navy|Off White": "linear-gradient(135deg, #1f2a44 50%, #f2ede2 50%)",
 "Noir": "#141414",
 "Noir 2": "#141414",
 "Noir Profond": "#0e0e0e",
 "Noir Recyclé": "#141414",
 "Noir/Blanc": "linear-gradient(135deg, #141414 50%, #ffffff 50%)",
 "Noir/Bleu": "linear-gradient(135deg, #141414 50%, #2f6db4 50%)",
 "Noir/Ecru": "linear-gradient(135deg, #141414 50%, #efe8d4 50%)",
 "Noir/Gris Chiné": "linear-gradient(135deg, #141414 50%, #9a9aa0 50%)",
 "Noir/Gris Fonce": "linear-gradient(135deg, #141414 50%, #9a9aa0 50%)",
 "Noir/Jaune": "linear-gradient(135deg, #141414 50%, #f2c500 50%)",
 "Noir/Kaki": "linear-gradient(135deg, #141414 50%, #6b6b47 50%)",
 "Noir/Lime": "linear-gradient(135deg, #141414 50%, #9bd333 50%)",
 "Noir/Rouge": "linear-gradient(135deg, #141414 50%, #c8102e 50%)",
 "Noir/Royal": "linear-gradient(135deg, #141414 50%, #1e4fbd 50%)",
 "Ochre": "#cf9f2b",
 "Off White| Navy": "linear-gradient(135deg, #f2ede2 50%, #1f2a44 50%)",
 "Or": "#c9a227",
 "Or Mat": "#c9a227",
 "Orange": "#e87722",
 "Orange 2": "#e87722",
 "Orange Brulee": "#e87722",
 "Orange Fluo": "#ff6a00",
 "Orange Fonce": "#a25318",
 "Orange Transparent": "#e8eef2",
 "Outremer": "#1b3b8c",
 "Oxblood Chine": "linear-gradient(135deg, #965a66 0%, #6d1a2b 45%, #8d4c5a 100%)",
 "Peche": "#f5b78f",
 "Petrole": "#1f5f6b",
 "Pool Blue": "#2f6db4",
 "Pop Orange": "#e87722",
 "Ribbon Pink": "#e58cb6",
 "Rose": "#e58cb6",
 "Rose Bonbon": "#e58cb6",
 "Rose Bébé": "#f1c0d7",
 "Rose Chine": "linear-gradient(135deg, #ecacca 0%, #e58cb6 45%, #eba5c6 100%)",
 "Rose Cremeux": "#f3ecd8",
 "Rose Flash": "#e58cb6",
 "Rose Fluo 2": "#ff3d8c",
 "Rose Folk/Ecru": "linear-gradient(135deg, #e58cb6 50%, #efe8d4 50%)",
 "Rose Fonce": "#a0627f",
 "Rose Halo": "#e58cb6",
 "Rose Moyen": "#e58cb6",
 "Rose Orchidée": "#e58cb6",
 "Rose Poudré New": "#f1c0d7",
 "Rose Pâle": "#e58cb6",
 "Rose Transparent": "#e8eef2",
 "Rose/Blanc": "linear-gradient(135deg, #e58cb6 50%, #ffffff 50%)",
 "Rouge": "#c8102e",
 "Rouge 2": "#c8102e",
 "Rouge Piment": "#c8102e",
 "Rouge Recyclé": "#c8102e",
 "Rouge Tango": "#d94f30",
 "Rouge Transparent": "#e8eef2",
 "Rouge Vif": "#c8102e",
 "Rouge Vif / Blanc": "linear-gradient(135deg, #c8102e 50%, #ffffff 50%)",
 "Rouge/Blanc": "linear-gradient(135deg, #c8102e 50%, #ffffff 50%)",
 "Royal": "#1e4fbd",
 "Royal 2": "#1e4fbd",
 "Royal 3": "#1e4fbd",
 "Royal Recyclé": "#1e4fbd",
 "Royal Shirt": "#1e4fbd",
 "Royal/Blanc": "linear-gradient(135deg, #1e4fbd 50%, #ffffff 50%)",
 "Royal/Corail Fluo": "linear-gradient(135deg, #1e4fbd 50%, #f26d5f 50%)",
 "Royal/Jaune Fluo": "linear-gradient(135deg, #1e4fbd 50%, #f2c500 50%)",
 "Sable": "#dcc9a3",
 "Sang De Bœuf": "#6d1a2b",
 "Taupe": "#8a7a6b",
 "Terracotta": "#b35a3c",
 "Terre": "#8a5a3b",
 "Terre Ombre": "#8a5a3b",
 "Tilleul": "#c4cf8e",
 "Titanium": "#8f9296",
 "Transparent": "#e8eef2",
 "Turquoise": "#30b8c4",
 "Turquoise/Blanc": "linear-gradient(135deg, #30b8c4 50%, #ffffff 50%)",
 "Vert": "#2e8b46",
 "Vert 2": "#2e8b46",
 "Vert Absinthe": "#2e8b46",
 "Vert Armée Vert": "#4a5240",
 "Vert Bourgeon": "#2e8b46",
 "Vert Bouteille": "#2e8b46",
 "Vert Clair Chine": "linear-gradient(135deg, #acd1b6 0%, #8cbf99 45%, #a5cdaf 100%)",
 "Vert Cremeux": "#f3ecd8",
 "Vert Empire": "#2e8b46",
 "Vert Fluo": "#5aff00",
 "Vert Foncé": "#206131",
 "Vert Foncé 2": "#206131",
 "Vert Foret": "#1f4d2e",
 "Vert Foret/Blanc": "linear-gradient(135deg, #1f4d2e 50%, #ffffff 50%)",
 "Vert Glace": "#2e8b46",
 "Vert Golf": "#2e8b46",
 "Vert Irlandais": "#2e8b46",
 "Vert Lime Transparent": "#e8eef2",
 "Vert Menthe": "#9adbb4",
 "Vert Pomme": "#7cb342",
 "Vert Prairie": "#6aa84f",
 "Vert Prairie /Blanc": "linear-gradient(135deg, #6aa84f 50%, #ffffff 50%)",
 "Vert Prairie/Bleu": "linear-gradient(135deg, #6aa84f 50%, #2f6db4 50%)",
 "Vert Prairie/Vert Glace": "linear-gradient(135deg, #6aa84f 50%, #2e8b46 50%)",
 "Vert Printemps": "#2e8b46",
 "Vert Pro": "#2e8b46",
 "Vert Sapin": "#2e8b46",
 "Vert Transparent": "#e8eef2",
 "Vert Vif": "#2e8b46",
 "Vert-Jaune Sécurité": "#2e8b46",
 "Vieux Rose": "#e58cb6",
 "Violet": "#6a4b9c",
 "Violet Clair": "#ad9cc9",
 "Violet Fonce": "#4a356d",
 "Violet Transparent": "#e8eef2",
 "Violet Vintage": "#6a4b9c",
 "Zinc": "#7d8087"
};
